import React from 'react'
import { ReactComponent as Eye } from '../images/eye-solid.svg';

const ProjectCard = ({projectData}) => {
  return (
      <div className="projectCard">
          <div className="row">
              <div className="col-md-6 projectDescription">
                  <div className="projectDescriptionContainer">
                      <h5 className="projectName">{projectData.name}</h5>
                      <p className="projectDescription">{projectData.desc}</p>
                      <div className="projectButtons">

                          <a href={projectData.liveLink} className='live' target='_blank' rel="noreferrer">
                              <Eye />
                              See Live 🚀

                          </a>
                      </div>
                  </div>
              </div>
              <div className="col-md-6 projectImage">
                  <div className="projectImageContainer">
                      <img src={projectData.image1} alt="membersHq" className='photo-1' />
                      <img src={projectData.image2} alt="membersHq" className='photo-2' />
                      <img src={projectData.image3} alt="membersHq" className='photo-3' />
                  </div>
              </div>
          </div>
      </div>
  )
}

export default ProjectCard